import type * as ents from '@attain-apps/entities'
import { XMLBuilder } from 'fast-xml-parser'

import type { Edge } from './edge'

export interface Data {
  nodes: readonly ents.core.display.tree.Node[]
  edges: readonly Edge[]
}
export namespace Data {
  /**
   * Encodes {@link Data} as XML
   *
   * @see {@link toJson}, {@link fromJson}
   */
  export function toXml(
    data: toXml.Data,
    { format = false }: EncodingOptions = {},
  ): string {
    const xmlBuilder = new XMLBuilder({ format })
    return xmlBuilder.build(data)
  }
  export namespace toXml {
    export interface Node {
      id: ents.core.display.tree.Node.Id
      name: string
      description: string
      jobTitle: string
      skills: readonly ents.core.display.tree.Node.Skill[]
      projectEngagements: readonly ents.core.display.tree.Node.ProjectEngagement[]
    }
    export interface Data {
      nodes: Node[]
      edges: readonly Edge[]
    }
  }
  /**
   * Encodes {@link Data} as JSON
   *
   * @see {@link toXml}, {@link fromJson}
   */
  export function toJson(
    data: Data,
    { format = false }: EncodingOptions = {},
  ): string {
    return JSON.stringify(data, null, format ? 2 : undefined)
  }
  /**
   * Decodes JSON to {@link Data}
   *
   * @see {@link toJson}, {@link toXml}
   */
  export function fromJson(json: string): Data {
    return JSON.parse(json) as Data
  }

  export interface EncodingOptions {
    /**
     * Set to `true` to make the results more readable
     *
     * @default false
     */
    format?: boolean
  }
}
